import styled, { css } from 'styled-components';
import { rem } from 'polished';

const infoAlert = css`
  color: ${props => props.theme.colors.secondary};
  border: 1px solid ${props => props.theme.colors.secondary};
`;

const successAlert = css`
  color: ${props => props.theme.colors.success};
  border: 1px solid ${props => props.theme.colors.success};
`;

const warningAlert = css`
  color: ${props => props.theme.colors.warning};
  border: 1px solid ${props => props.theme.colors.warning};
`;

const errorAlert = css`
  color: ${props => props.theme.colors.error};
  border: 1px solid ${props => props.theme.colors.error};
`;

const lightAlert = css`
  color: ${props => props.theme.colors.light};
  border: 1px solid ${props => props.theme.colors.light};
`;

const StyledAlerts = styled.p`
  font-size: ${rem('16px')};
  ${props => props.type === 'info' && infoAlert};
  ${props => props.type === 'success' && successAlert};
  ${props => props.type === 'warning' && warningAlert};
  ${props => props.type === 'error' && errorAlert};
  ${props => props.type === 'light' && lightAlert};
  padding: ${rem('5px')} ${rem('10px')};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  transition: opacity 1s;

  ${props =>
    props.visible && props.visible
      ? css`
          opacity: 1;
          display: 'block';
        `
      : css`
          opacity: 0;
          display: none;
        `}

  .alert-icon {
    position: relative;
    top: 3px;
  }
`;

export { StyledAlerts };
